import React from 'react';
import PropTypes from 'prop-types';
import {getText} from 'helpers/language-helper';
import {generalUiTexts} from 'data/ui-texts/general-ui-texts';
import './loading.scss';

const Loading = ({languageId}) => {
	return (
		<div className="Loading">
			<div className="Loading-panel" >
				<div className="Loading-content">
					<div className="Loading-circles">
						<div className="Loading-circle" />
						<div className="Loading-circle" />
						<div className="Loading-circle" />
					</div>
					<div className="Loading-text">{getText(generalUiTexts.loading, languageId)}...</div>
				</div>
			</div>
		</div>
	);
};

Loading.propTypes = {
	languageId: PropTypes.string.isRequired
};

export default Loading;
